import React, { useEffect } from 'react';
import { injectIntl, WrappedComponentProps } from '@kyruus/intl';
import { ProviderMatchProviderV9, PMCConfig } from '@kyruus/types';

import {
  CardContentContainer,
  CardContentHeader,
  CardContentHorizontalList,
  CardContentHorizontalListItem,
  ProviderInformationCard
} from './styles';
import { isSummaryDataConfigured, pruneIgnoredValues } from '../../lib/utils';
import messages from '../../lib/messages';
import { withErrorBoundary } from '../ErrorFallback/with-error-boundary';

const AgeGroupsSeen = ({
  provider,
  config,
  shouldSkipRender,
  intl
}: {
  provider: ProviderMatchProviderV9;
  config: PMCConfig;
  shouldSkipRender: (component: string) => void;
} & WrappedComponentProps): React.ReactElement | null => {
  const prunedProvider = pruneIgnoredValues(
    provider,
    'age_groups_seen',
    config
  );

  const renderItems = prunedProvider.age_groups_seen;

  const skipRendering =
    !isSummaryDataConfigured('age_groups_seen', config) ||
    !Array.isArray(prunedProvider.age_groups_seen) ||
    prunedProvider.age_groups_seen.length === 0;

  useEffect(() => {
    if (skipRendering) {
      // callback to the parent component to skip rendering
      shouldSkipRender('age-groups-seen');
    }
  }, []);

  if (skipRendering) {
    // do not render if summary_data is not configured or data not present or is empty
    return null;
  }

  return (
    <ProviderInformationCard data-testid="info-card-age-groups-seen">
      <CardContentContainer>
        <CardContentHeader>
          {intl.formatMessage(messages.ageGroupsSeenHeader)}
        </CardContentHeader>
        <CardContentHorizontalList>
          {renderItems.map((item: string | React.ReactNode, index: number) => (
            <CardContentHorizontalListItem
              key={`${(item || '').toString()}-${index}`}
            >
              {item}
            </CardContentHorizontalListItem>
          ))}
        </CardContentHorizontalList>
      </CardContentContainer>
    </ProviderInformationCard>
  );
};

export default withErrorBoundary(injectIntl(AgeGroupsSeen));
